// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3qNrf","rootSuccess":"CompleteLink_rootSuccess__1OFYi","rootFailure":"CompleteLink_rootFailure__h5Dli","isDisabled":"CompleteLink_isDisabled__2e_U6"};